<template>
  <div>
    <div id="welcome-goodbye-container">
      <div class="header">
        <img src="/static/hilab_white.png" alt class="image">
      </div>
      <router-view/>
    </div>
    <div class="div-copyright copyrightfooter">
      <div class="text-block">Copyright © 2019 Hi Technologies, All Rights Reserved.</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UserIdentification from "../components/UserIdentification";

export default {
  name: "welcome-goodbye",
  components: {
    UserIdentification
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
#welcome-goodbye-container {
  min-height: calc(100vh - 40px);
  display: block;
  padding-left: 10vw;
  padding-right: 10vw;
}
@media (min-width: 991px) {
  #welcome-goodbye-container::before {
    content: "";
    height: 20vmax;
    width: 31vmax;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    background-image: url(/static/people_talking.png);
    background-position: 0 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: local;
  }
}
@media (max-width: 991px) {
  #welcome-goodbye-container::before {
    content: "";
    height: 40vmin;
    width: 36vmin;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
    background-image: url(/static/woman.png);
    background-position: 0 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: local;
  }
}

.div-copyright {
  position: relative;
  left: 0%;
  top: auto;
  right: 0%;
  bottom: 0%;
  background-color: #053541;
  text-align: center;
}

.text-block {
  padding-top: 12px;
  padding-bottom: 12px;
  font-family: Muli, sans-serif;
  color: #ececec;
  font-size: 11px;
}

.header {
  position: relative;
  left: 0px;
  top: 0px;
  right: 0px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding-bottom: 30px;
  padding-right: 170px;
  padding-left: 170px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  -ms-grid-columns: 0.25fr 1fr;
  grid-template-columns: 0.25fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}

.image {
  position: absolute;
  left: 25px;
  top: 25px;
  right: auto;
  bottom: auto;
  height: 35px;
}
#welcome-goodbye-container::after {
  content: " ";
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: -2;
  background-image: url("/static/triangle_blue.png");
  background-position: 100% 30vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: #003f51;
}

@media (max-width: 991px) {
  #welcome-goodbye-container::after {
    content: " ";
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: -2;
    background-image: url("/static/triangle_blue.png");
    background-position-y: 100%;
    background-position-x: 0;
    background-size: contain;
    background-repeat: no-repeat;
    background-attachment: fixed;
  }
}

@media (max-width: 991px) {
  .header {
    padding: 10px 10px;
  }
  .header > img {
    top: 25px;
    left: 25px;
    height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/WelcomeGoodbye.vue